(()=>{
const d=document,b=d.body;
const rm=matchMedia('(prefers-reduced-motion: reduce)').matches;
const ss={get(k){try{return sessionStorage.getItem(k)}catch(e){return null}},set(k,v){try{sessionStorage.setItem(k,v)}catch(e){}}};
const R=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
const money=c=>'₹'+(c/100).toLocaleString('en-IN',{maximumFractionDigits:2});
const intro=()=>b.classList.add('is-in');

/* loader */
const ld=d.querySelector('[data-loader]');
if(ld){
  if(ss.get('gh-seen')||rm){ld.remove();intro();}
  else{
    const n=ld.querySelector('[data-n]');let i=0;
    const t=setInterval(()=>{i+=1+Math.floor(Math.random()*9);if(i>=100){i=100;clearInterval(t);setTimeout(()=>{ld.classList.add('done');intro();ss.set('gh-seen','1');setTimeout(()=>ld.remove(),1100)},160)}if(n)n.textContent=String(i).padStart(3,'0')},42);
  }
}else intro();

/* reveal */
if('IntersectionObserver' in window){
  const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}}),{threshold:.12,rootMargin:'0px 0px -6% 0px'});
  d.querySelectorAll('[data-reveal]').forEach(el=>io.observe(el));
}else d.querySelectorAll('[data-reveal]').forEach(el=>el.classList.add('is-in'));

/* header, progress, words */
const h=d.querySelector('[data-hdr]'),pg=d.querySelector('[data-prog]'),words=[...d.querySelectorAll('[data-words]')];
let ly=0,tick=false;
const onScroll=()=>{
  const y=scrollY;
  if(h){h.classList.toggle('is-solid',y>30);h.classList.toggle('is-hidden',y>ly&&y>320&&!b.classList.contains('cart-open'));}
  ly=y;
  if(pg){const m=d.documentElement.scrollHeight-innerHeight;pg.style.setProperty('--p',m>0?(y/m).toFixed(4):0)}
  words.forEach(el=>{const ws=el._w||(el._w=[...el.querySelectorAll('.w')]);const r=el.getBoundingClientRect();const p=Math.min(1,Math.max(0,(innerHeight*.82-r.top)/(r.height*.9+innerHeight*.25)));const n=rm?ws.length:Math.round(p*ws.length);ws.forEach((w,i)=>w.classList.toggle('on',i<n))});
  tick=false;
};
addEventListener('scroll',()=>{if(!tick){tick=true;requestAnimationFrame(onScroll)}},{passive:true});
onScroll();

/* cursor */
const cu=d.querySelector('[data-cursor]');
if(cu&&matchMedia('(pointer:fine)').matches&&!rm){
  let x=-100,y=-100,cx=-100,cy=-100;
  addEventListener('mousemove',e=>{x=e.clientX;y=e.clientY;cu.style.opacity=1},{passive:true});
  d.addEventListener('mouseleave',()=>cu.style.opacity=0);
  const loop=()=>{cx+=(x-cx)*.22;cy+=(y-cy)*.22;cu.style.transform=`translate(${cx}px,${cy}px) translate(-50%,-50%)`;requestAnimationFrame(loop)};loop();
  d.addEventListener('mouseover',e=>{const t=e.target.closest('a,button,label,summary,input');const card=e.target.closest('.card');cu.classList.toggle('big',!!card);cu.classList.toggle('hov',!!t&&!card)});
}

/* countdown */
d.querySelectorAll('[data-cd]').forEach(el=>{
  const end=new Date(el.dataset.cd).getTime();
  const s=['d','h','m','s'].map(k=>el.querySelector('[data-'+k+']'));
  const run=()=>{const t=end-Date.now();if(isNaN(end)||t<=0){el.classList.add('live');return}
    const v=[Math.floor(t/864e5),Math.floor(t/36e5)%24,Math.floor(t/6e4)%60,Math.floor(t/1e3)%60];
    s.forEach((e,i)=>{if(e)e.textContent=String(v[i]).padStart(2,'0')});setTimeout(run,1000)};
  run();
});

/* mobile menu */
const mn=d.querySelector('[data-mnav]');
d.querySelectorAll('[data-menu]').forEach(btn=>btn.addEventListener('click',()=>{if(!mn)return;const o=mn.classList.toggle('open');b.classList.toggle('lock',o);btn.setAttribute('aria-expanded',o)}));
if(mn)mn.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{mn.classList.remove('open');b.classList.remove('lock')}));

/* dialogs */
d.querySelectorAll('[data-dlg-open]').forEach(btn=>btn.addEventListener('click',()=>{const g=d.getElementById(btn.dataset.dlgOpen);if(g&&g.showModal)g.showModal()}));
d.querySelectorAll('[data-dlg-close]').forEach(btn=>btn.addEventListener('click',()=>btn.closest('dialog').close()));
d.querySelectorAll('dialog').forEach(g=>g.addEventListener('click',e=>{if(e.target===g)g.close()}));

/* cart drawer */
const dr=d.querySelector('[data-drawer]');
const setCount=n=>d.querySelectorAll('[data-count]').forEach(e=>e.textContent=n);
const esc=s=>String(s==null?'':s).replace(/[&<>']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;'}[c]));
async function renderCart(){
  if(!dr)return;
  const c=await fetch(R+'cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json());
  setCount(c.item_count);
  const box=dr.querySelector('[data-items]'),foot=dr.querySelector('[data-foot]');
  if(!c.items.length){box.innerHTML=`<div class='dr-empty'><p class='disp'>Empty.</p><p class='mono'>Nothing here yet. Classic Monday.</p><p><a class='btn' href='${R}collections/all'>Shop the drop <i>&rarr;</i></a></p></div>`;foot.hidden=true;return}
  foot.hidden=false;
  box.innerHTML=c.items.map((it,ix)=>{const im=it.image?it.image+(it.image.indexOf('?')>-1?'&':'?')+'width=220':'';
    return `<div class='dr-item'><a href='${it.url}'>${im?`<img src='${im}' alt='' loading='lazy'>`:''}</a><div><a class='card-title' href='${it.url}'>${esc(it.product_title)}</a>${it.variant_title?`<p class='mono'>${esc(it.variant_title)}</p>`:''}<div class='qty'><button type='button' data-line='${ix+1}' data-q='${it.quantity-1}' aria-label='Decrease'>&minus;</button><span>${it.quantity}</span><button type='button' data-line='${ix+1}' data-q='${it.quantity+1}' aria-label='Increase'>+</button></div></div><p class='card-price'>${money(it.final_line_price)}</p></div>`}).join('');
  dr.querySelector('[data-total]').textContent=money(c.total_price);
  box.querySelectorAll('[data-q]').forEach(btn=>btn.addEventListener('click',async()=>{btn.disabled=true;await fetch(R+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line:+btn.dataset.line,quantity:+btn.dataset.q})});renderCart()}));
}
const openCart=()=>{b.classList.add('cart-open');renderCart()};
const closeCart=()=>b.classList.remove('cart-open');
d.querySelectorAll('[data-open-cart]').forEach(a=>a.addEventListener('click',e=>{if(!dr)return;e.preventDefault();openCart()}));
d.querySelectorAll('[data-close-cart]').forEach(a=>a.addEventListener('click',closeCart));
addEventListener('keydown',e=>{if(e.key==='Escape'){closeCart();if(mn&&mn.classList.contains('open')){mn.classList.remove('open');b.classList.remove('lock')}}});

/* product form */
d.querySelectorAll('[data-pform]').forEach(f=>{
  const vs=JSON.parse(f.querySelector('[data-variants]').textContent);
  const idI=f.querySelector('[name=id]'),btn=f.querySelector('[data-atc]'),mb=d.querySelector('[data-matc]'),bar=d.querySelector('[data-matc-bar]');
  const groups=[...f.querySelectorAll('[data-opt]')];
  const match=sel=>vs.find(v=>v.options.every((o,i)=>o===sel[i]));
  const sync=()=>{
    if(!groups.length)return;
    const sel=groups.map(g=>{const c=g.querySelector('input:checked');return c?c.value:null});
    const v=match(sel);
    groups.forEach((g,gi)=>g.querySelectorAll('input').forEach(inp=>{const t=sel.slice();t[gi]=inp.value;const m=match(t);inp.nextElementSibling.classList.toggle('na',!m||!m.available)}));
    if(!v){btn.disabled=true;btn.querySelector('span').textContent='Unavailable';return}
    idI.value=v.id;d.querySelectorAll('[data-price]').forEach(p=>p.textContent=money(v.price));
    btn.disabled=!v.available;btn.querySelector('span').textContent=v.available?btn.dataset.add:btn.dataset.sold;if(mb)mb.disabled=!v.available;
    try{const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u)}catch(e){}
  };
  f.addEventListener('change',sync);sync();
  f.addEventListener('submit',async e=>{
    if(!dr)return;e.preventDefault();btn.classList.add('busy');
    const r=await fetch(R+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:+idI.value,quantity:1}]})});
    btn.classList.remove('busy');
    if(r.ok)openCart();else{const j=await r.json().catch(()=>({}));alert(j.description||'Could not add to cart. Try again.')}
  });
  if(mb)mb.addEventListener('click',()=>f.requestSubmit?f.requestSubmit():f.submit());
  if(bar&&'IntersectionObserver' in window){new IntersectionObserver(([e])=>bar.classList.toggle('show',!e.isIntersecting&&e.boundingClientRect.top<0)).observe(btn)}
});
})();
